/**
 * Invalidate strategy observes the notifications from the JSDataCacheManager,
 * and invalidate cache items based on the rules.
 */
export class InvalidateStrategy {
  /**
   * Initialize a cache manager for applying the invalidate strategy
   * @param {JSDataCacheManager} cacheManager - The cache manager to initialize
   * @returns {void}
   */
  initializeCacheManager(cacheManager) {
    cacheManager.subscribe(this);
  }

  /**
   * Handler for the beforeExecute notification
   * @abstract
   * @param {JSDataCacheManager} cacheManager - The subject of the notification
   * @param {BeforeExecuteParameters} params - The notification parameters
   * @returns {void}
   */
  beforeExecute(/* cacheManager, params */) { }

  /**
   * Handler for the afterExecute notification
   * @abstract
   * @param {JSDataCacheManager} cacheManager - The subject of the notification
   * @param {AfterExecuteParameters} params - The notification parameters
   * @returns {void}
   */
  afterExecute(/* cacheManager, params */) { }

  /**
   * Handler for the beforeInvalidate notification
   * @abstract
   * @param {JSDataCacheManager} cacheManager - The subject of the notification
   * @param {string} resource - The resource being invalidated
   * @returns {void}
   */
  beforeInvalidate(/* cacheManager, resource */) { }

  /**
   * Handler for the afterInvalidate notification
   * @abstract
   * @param {JSDataCacheManager} cacheManager - The subject of the notification
   * @param {string} resource - The resource being invalidated
   * @returns {void}
   */
  afterInvalidate(/* cacheManager, resource */) { }
}
